import {SlotFilter} from '../../../../OrderIntake/BulkCement/containers/slotManagement/types'
import {useHubQuery} from '../../QueryProvider'

export const useGetBulkCemSlots = (filterType: SlotFilter) => {
  return useHubQuery('getBulkCemSlots', [filterType], {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: false
  })
}
